import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { PessoaApiService } from "./shared/pessoa-api.service";
import { PessoasComponent } from "./pessoas.component";
import { PessoaListComponent } from "./pessoa-list/pessoa-list.component";
import { PessoasRoutingModule } from "./pessoas-routing.module";
import { PessoaFormComponent } from './pessoa-form/pessoa-form.component';
import { PessoaNavigationService } from "./shared/pessoa-navigation.service";
import { FuncionariosModule } from "../funcionarios/funcionarios.module";
import { PessoaService } from "./shared/pessoa.service";

@NgModule({
  imports: [
    SharedModule,
    FuncionariosModule,
    PessoasRoutingModule
  ],
  providers: [
    PessoaApiService,
    PessoaNavigationService,
    PessoaService
  ],
  declarations: [
    PessoasComponent,
    PessoaListComponent,
    PessoaFormComponent
  ]
})
export class PessoasModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoas/pessoas.module.ts
 **/